module.exports = __webpack_public_path__ + "img/perks-diamond.2ca4f583.svg";